// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 678 ? "component---src-pages-index-js" : chunkId) + "-" + {"175":"4f5eec3dd4c4a5e05eef","231":"b2d35ff9bb1952aa22d1","678":"4e395659fca3d669fa73","876":"8f04e718bc8460b75aa7"}[chunkId] + ".js";
};